export const defaultTaxReturnSubmissionState = {
	TaxReturnSubmissionData: [],
	Total: 0,
	CachedQuickSearchText: null,
	CachedFilterOptions: {},
	CachedFilterDisplay: {},
	AppendixTaxReturnSubmissionData: [],
	TaxReturnSubmissionHistoryData: [],
	TotalSubmissionHistoryData: 0,
	IsLoadingPaper: false,
	TaxReturnHavePaidReportData: {
		SummaryData: {
			TotalCount: 0
		},
		Data: []
	}
};

export default {
	...defaultTaxReturnSubmissionState
};
